<a
	[state]="state"
	[routerLink]="redirectLink && !disabled ? redirectLink : null"
	(click)="scrollToAnchor()"
	class="{{ disabled ? 'disable' : classTextColor }}"
	[ngClass]="customClass">
	<ng-content></ng-content>
</a>
